module.exports = __webpack_public_path__ + "static/goerges-red-57d86b74ccf7829aa9f028a67755f2ad.png";